module.exports = __webpack_public_path__ + "images/estimate_entry_banner/products_right_pc_b2c5ad9a72591e6c7efb2a775feb8f61.svg";